export type DefaultHandleLink = (url: string, target?: string) => Promise<void>;

/**
 * Default implementation for `core.routing.handleExternalLink` when a host app does not provide one.
 *
 * Uses `window.open` and defaults to opening in a new tab.
 */
export const defaultHandleLink: DefaultHandleLink = async (
  url: string,
  target = '_blank',
) => {
  // Guard against non-browser environments.
  if (typeof window === 'undefined') return;

  window.open(url, target, 'noreferrer');
};
